import {useMemo} from 'react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useBrand, toBrandCode} from '../contexts/brand-context'
import {getSiteEnvVarValue, resolveBrandScopedValue} from '../utils/site-config'

/* Client-side view of the Optimizely FX config (site pref → MRT env, exposed via
 * window.__CONFIG__) plus the tree scope (brandSlug, localeId) every Optimizely
 * hook needs. Memoised: resolveBrandScopedValue parses JSON. */
export const useOptimizelyFxConfig = () => {
    const {site, locale} = useMultiSite()
    const {brandId} = useBrand()
    const {app: appConfig} = getConfig()
    const siteId = site?.id
    const localeId = locale?.id || locale?.alias || 'en-CA'

    return useMemo(() => {
        const sdkKey = resolveBrandScopedValue(
            getSiteEnvVarValue(appConfig, 'OPTIMIZELY_SDK_KEY', siteId),
            brandId
        )
        return {
            enabled:
                getSiteEnvVarValue(appConfig, 'OPTIMIZELY_AB_TESTING_ENABLED', siteId) === 'true' &&
                !!sdkKey,
            sdkKey,
            siteId,
            brandSlug: `${toBrandCode(brandId).toLowerCase()}-web`,
            localeId
        }
    }, [appConfig, siteId, brandId, localeId])
}
